<ng-template [ngIf]="searchFlightForm !== 1">
  <form [formGroup]="searchFlightForm">
    <div id="pnsrch" class="sidebar-pnsrch">
      <div class="pnContent commonFormsCss">
        <div>
          <h3>Search Flights</h3>
          <div class="pnclose">
            <a (click)="closePannel()"><i class="fa fa-chevron-circle-left fa1x"></i></a>
          </div>
          <div formArrayName="destination" class="destination">
            <div *ngFor="let p of inp_arr('destination').controls; let i = index" [formGroupName]="i">
              <ng-template [ngIf]="i === 0">
                <div class="row mb-2">
                  <div class="col-sm-6">
                    <span class="sml">Departure</span><br />
                    <ng-autocomplete
                      class="selector"
                      [data]="airPortSearchList"
                      [searchKeyword]="filterBy"
                      (inputFocused)="updateAirportData($event, 'departure', i)"
                      (inputChanged)="searchAirportsList($event, 'departure', i)"
                      (inputCleared)="removeAirportList('departure', i)"
                      (selected)="setValue($event, 'departure', i)"
                      formControlName="depature"
                      [itemTemplate]="itemTemplate"
                    >
                    </ng-autocomplete>
                    <ng-template #itemTemplate let-item>
                      <a [innerHTML]="item.City"></a>
                    </ng-template>
                  </div>
                  <div class="col-sm-6">
                    <span class="sml">Arrival</span><br />
                    <ng-autocomplete
                      class="selector"
                      [data]="airPortSearchList"
                      [searchKeyword]="filterBy"
                      (inputFocused)="updateAirportData($event, 'arrival', i)"
                      (inputChanged)="searchAirportsList($event, 'arrival', i)"
                      (inputCleared)="removeAirportList('arrival', i)"
                      (selected)="setValue($event, 'arrival', i)"
                      formControlName="arrival"
                      [itemTemplate]="itemTemplate"
                    >
                    </ng-autocomplete>
                    <ng-template #itemTemplate let-item>
                      <a [innerHTML]="item.City"></a>
                    </ng-template>
                  </div>
                  <div class="col-sm-6">
                    <br />
                    <input formControlName="depatureDate" (change)="setReturnDate()" type="date" class="form-control" />
                  </div>
                  <div class="col-sm-6" [formGroup]="searchFlightForm">
                    <span class="sml"><input id="rtn" name="rtn" type="checkbox" formControlName="haveReturn" /> Return</span><br />
                    <input
                      [min]="inp_arr('destination').value[0]['depatureDate']"
                      [class.disabled-datepicker]="!inp_group('haveReturn').value"
                      [readonly]="!inp_group('haveReturn').value"
                      formControlName="returnDate"
                      type="date"
                      class="form-control"
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-6">
                    <label for="outbounddepartureTime" class="sml"> Outbound Dep. Time </label><br />
                    <input type="time" id="outbounddepartureTime" name="outbounddepartureTime" formControlName="outbounddepartureTime" class="form-control" />
                  </div>

                  <div class="col-sm-6">
                    <label for="inbounddepartureTime" class="sml"> Inbound Dep. Time </label><br />
                    <input
                      [class.disabled-datepicker]="!inp_group('haveReturn').value"
                      [readonly]="!inp_group('haveReturn').value"
                      type="time"
                      id="inbounddepartureTime"
                      name="inbounddepartureTime"
                      formControlName="inbounddepartureTime"
                      class="form-control"
                    />
                  </div>
                </div>

                <div class="row">
                  <div class="col-sm-12">
                    <span class="sml">
                      <ng-template [ngIf]="inp_group('haveMultiCity').value">
                        <i id="ojicn" class="fa fa-plus blackText" (click)="addMultiCity()"></i>
                      </ng-template>
                      <ng-template [ngIf]="!inp_group('haveMultiCity').value">
                        <i id="ojicn" class="fa fa-minus blackText" (click)="removeMultiCity()"></i>
                      </ng-template>
                      Multi City
                    </span>
                  </div>
                </div>
              </ng-template>
              <ng-template [ngIf]="i !== 0">
                <div class="row mb-2">
                  <div class="col-sm-6">
                    <div class="row">
                      <div class="col-sm-6 pe-1">
                        <ng-autocomplete
                          [data]="airPortSearchList"
                          (inputFocused)="updateAirportData($event, 'departure', i)"
                          [searchKeyword]="filterBy"
                          (inputChanged)="searchAirportsList($event, 'departure', i)"
                          (selected)="setValue($event, 'departure', i)"
                          (inputCleared)="removeAirportList('departure', i)"
                          formControlName="depature"
                          [itemTemplate]="itemTemplate"
                        >
                        </ng-autocomplete>
                        <ng-template #itemTemplate let-item>
                          <a [innerHTML]="item.City"></a>
                        </ng-template>
                      </div>
                      <div class="col-sm-6 ps-1">
                        <ng-autocomplete
                          [data]="airPortSearchList"
                          [searchKeyword]="filterBy"
                          (inputFocused)="updateAirportData($event, 'arrival', i)"
                          (inputChanged)="searchAirportsList($event, 'arrival', i)"
                          (selected)="setValue($event, 'arrival', i)"
                          (inputCleared)="removeAirportList('arrival', i)"
                          formControlName="arrival"
                          [itemTemplate]="itemTemplate"
                        >
                        </ng-autocomplete>
                        <ng-template #itemTemplate let-item>
                          <a [innerHTML]="item.City"></a>
                        </ng-template>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <input formControlName="depatureDate" type="date" class="form-control" />
                  </div>
                </div>
              </ng-template>
            </div>
          </div>
        </div>
        <div class="row mt-3 mb-2">
          <div class="col-sm-12 mt-1">
            <span class="sml"> Passengers </span>
          </div>
        </div>
        <div class="row mb-4 selectPannel">
          <div class="col-sm-3">
            <span class="smx">Adults</span>
            <select class="form-select form-control" formControlName="adults">
              <option *ngFor="let adult of adults" value="{{ adult }}">{{ adult }}</option>
            </select>
          </div>
          <div class="col-sm-3 pl-0">
            <span class="smx">YoungAdult</span><br />
            <select class="form-select form-control" formControlName="youngAdults">
              <option *ngFor="let youngAdult of youngAdults" value="{{ youngAdult }}">{{ youngAdult }}</option>
            </select>
          </div>
          <div class="col-sm-3 pl-0">
            <span class="smx">Children</span><br />
            <select class="form-select" formControlName="childs">
              <option *ngFor="let child of childrens" value="{{ child }}">{{ child }}</option>
            </select>
          </div>
          <div class="col-sm-3 pl-0">
            <span class="smx">Infants</span><br />
            <select class="form-select" formControlName="infants">
              <option *ngFor="let infant of infants" value="{{ infant }}">{{ infant }}</option>
            </select>
          </div>
        </div>
        <div class="row mt-10">
          <div id="fareprf" class="col-sm-12">
            <span class="sml"> Fare Preference </span><br />
            <div style="width: 100%; height: 100%">
              <ng-multiselect-dropdown
                [placeholder]="'Select a Fare Preference'"
                [settings]="farePreferenceSettings"
                class="fare-preference-dropdown"
                formControlName="farePreference"
                [data]="farePreferenceList"
              >
              </ng-multiselect-dropdown>
            </div>
          </div>
        </div>
        <div class="row mt-10">
          <div class="col-sm-12">
            <span class="sml"> Cabin Preference </span><br />
            <select id="cabin" name="cabin" formControlName="cabinPreferences" class="form-control  form-select">
              <option *ngFor="let cabin of cabinPreferences" [value]="cabin.code_id">
                {{ cabin.code_name }}
              </option>
            </select>
          </div>
        </div>
        <!--To be implemented as part of future requirement -->
        <div class="row mt-10">
          <div class="col-sm-5">
            <span class="sml"> Calendar Days </span><br />
            <label class="sml" for="calDBF">Days Before</label>
            <select id="calDBf" name="calDBF" class="form-control form-select" formControlName="calenderDays1">
              <option class="form-control" *ngFor="let calendar of calendarDays" [value]="calendar">{{ calendar }}</option>
            </select>
          </div>
          <div class="col-sm-5">
            <br />
            <label class="sml" for="calDBF">Days After</label>
            <select id="calDAf" name="calDAF" class="form-control form-select" formControlName="calenderDays2">
              <option class="form-control" *ngFor="let calendar of calendarDays" [value]="calendar">{{ calendar }}</option>
            </select>
          </div>
        </div>
        <div class="wrapToggle mt-4">
          <div class="flexTop">
            <ng-toggle
              onColor="{{ toggleOptions.onColor }}"
              [onText]="'Fare Rules'"
              offColor="{{ toggleOptions.offColor }}"
              [offText]="'No Fare Rules'"
              [size]="toggleOptions.size"
              formControlName="fareRules"
            >
            </ng-toggle>
            <ng-toggle
              onColor="{{ toggleOptions.onColor }}"
              [onText]="'Connection'"
              offColor="{{ toggleOptions.offColor }}"
              [offText]="'Direct Only'"
              [size]="toggleOptions.size"
              formControlName="connections"
            >
            </ng-toggle>
          </div>
          <div class="flexTop">
            <ng-toggle
              onColor="{{ toggleOptions.onColor }}"
              [onText]="'Any Luggage'"
              offColor="{{ toggleOptions.offColor }}"
              [offText]="'HandBag Only'"
              [size]="toggleOptions.size"
              formControlName="luggage"
            >
            </ng-toggle>
            <ng-toggle
              onColor="{{ toggleOptions.onColor }}"
              [onText]="'Short Sell &nbsp; &nbsp;'"
              offColor="{{ toggleOptions.offColor }}"
              [offText]="'Long Sell &nbsp; &nbsp;'"
              [size]="toggleOptions.size"
              formControlName="shortSell"
            >
            </ng-toggle>
          </div>
        </div>
        <div class="row mt-30">
          <div class="col-sm-8">
            <button type="button" (click)="searchAirlineOffers()" role="button" class="ba-btn ba-btn-vthin ba-btn-w100 pull-right">Search</button>
          </div>
        </div>
      </div>
    </div>
  </form>
</ng-template>
